<section class="feedback-page">
  <div class="feedback-panel">
    <div class="feedback-header">
      <div>
        <h1>Anonymous Feedback</h1>
        <p>{{ isAdmin ? 'Review and export submitted feedback.' : 'Your identity is not saved with this feedback.' }}</p>
      </div>
      <div class="feedback-actions">
        @if (isAdmin) {
          <button mat-button [routerLink]="['/home/anonymous-feedback/list']">
            View Feedback
          </button>
          <button
            mat-raised-button
            color="primary"
            (click)="exportFeedback()"
            [disabled]="isExcelExporting"
          >
            @if (isExcelExporting) {
              <span class="spinner-size">
                <mat-spinner [diameter]="18"></mat-spinner>
              </span>
            }
            {{ isExcelExporting ? 'Exporting...' : 'Export Excel' }}
          </button>
        }
        @if (!isAdmin) {
          <button mat-button [routerLink]="['/home/anonymous-feedback/my']">
            My Feedback
          </button>
        }
      </div>
    </div>

    @if (!isAdmin) {
      <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()" class="feedback-form">
        <mat-form-field appearance="outline" class="feedback-field">
          <mat-label>Feedback</mat-label>
          <textarea
            matInput
            formControlName="feedback"
            rows="8"
            maxlength="2000"
            placeholder="Share your feedback anonymously">
          </textarea>
          <mat-hint align="end">{{ feedbackForm.get('feedback')?.value?.length || 0 }}/2000</mat-hint>
          @if (feedbackForm.get('feedback')?.hasError('required')) {
            <mat-error>
              Feedback is required.
            </mat-error>
          }
          @if (feedbackForm.get('feedback')?.hasError('maxlength')) {
            <mat-error>
              Feedback cannot exceed 2000 characters.
            </mat-error>
          }
          @if (feedbackForm.get('feedback')?.hasError('dailyLimit')) {
            <mat-error>
              You have reached today's feedback limit. Please try again tomorrow.
            </mat-error>
          }
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Submitting...' : 'Submit Feedback' }}
        </button>
      </form>
    }
  </div>
</section>
